import React, { ChangeEvent, FocusEvent, TextareaHTMLAttributes } from "react";
import { Form } from "react-bootstrap";
import "./form-textarea.scss";
import ErrorMessageComponent from "../ErrorMessage/ErrorMessage";

type FormTextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  value: string;
  name?: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: FocusEvent<HTMLTextAreaElement>) => void;
  label?: string;
  labelClassName?: string;
  required?: boolean;
  placeholder?: string;
  error?: string;
  touched?: boolean;
  rows?: number;
  className?: string;
  subtext?: string;
  [x: string]: any;
};

const FormTextArea = (props: FormTextAreaProps) => {
  const {
    value,
    name,
    onChange,
    onBlur,
    label,
    labelClassName,
    required = false,
    placeholder,
    error,
    touched,
    rows = 5,
    className,
    subtext,
    disabled,
    ...rest
  }: FormTextAreaProps = props;

  return (
    <>
      <div>
        {label && (
          <Form.Label className={labelClassName}>
            {label}
            {required && <span>*</span>}
          </Form.Label>
        )}
        {subtext && <div className="input-field-subtext">{subtext}</div>}
      </div>
      <textarea
        className={`form-textarea ${error && touched ? "error-border" : ""} ${className} ${disabled ? "read-only" : ""}`}
        placeholder={placeholder ?? label}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows ?? 5}
        disabled={disabled}
        {...rest}
      />
      <ErrorMessageComponent touched={touched} error={error} />
    </>
  );
};

export default FormTextArea;
